<template>
  <div class="contact_index">
    <div class="contact_index_text">
      <p style="font-size: 24px;margin-bottom: 2vh" class="animate__fadeInUp animate__animated">关于我们</p>
      <p style="font-size: 36px;margin-bottom: 2vh" class="animate__fadeInUp animate__animated animate__delay-1s">为资本寻路 为新生力量赋能</p>
      <p style="font-size: 14px;margin-bottom: 0" class="animate__fadeInUp animate__animated animate__delay-2s">SIG是总部设于美国的全球领先的量化交易金融公司，拥有独有的创新、严谨的交易理念和技术，</p>
      <p style="font-size: 14px" class="animate__fadeInUp animate__animated animate__delay-2s">是高性能、低延迟交易的全球领导者和创新者。</p>
      <div style="padding-top: 2vh" class="animate__fadeInUp animate__animated animate__delay-3s">
        <a-button v-on:click="next_page" type="ghost" shape="circle-outline" size="large">
          <template v-slot:icon>
            <DownOutlined>
            </DownOutlined>
          </template>
        </a-button>
      </div>
    </div>
  </div>
</template>
<script>
import {DownOutlined} from '@ant-design/icons-vue'

export default {
  name: 'Contact_index',
  components: {DownOutlined,},
  setup() {
    const next_page = () => {
      document.documentElement.scrollBy({
        top: window.innerHeight * 90 / 100,
        behavior: "smooth",
      })
    }
    return {next_page}
  }

}
</script>
<style scoped>
.contact_index {
  background-image: url("../../../assets/background/contact_index.jpg");
  height: 100vh;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  margin: 0;
  text-align: left;
}

.contact_index_text {
  padding-top: 40vh;
  margin-left: 12vw;
}

.index_down {
  padding-top: 2vh;
  padding-left: 6vw;
}
</style>